export enum TokenType {
  BOOT = 'BOOT',
  AUTO = 'AUTO',
  ISO14443 = 'ISO14443',
  EMVCO = 'EMVCO',
  EMAID = 'EMAID'
}
